import { EnergyStatusState } from './types'

export const state: EnergyStatusState = {
  projectId: '',
  projectName: '',
  isKioskMode: false,
  energyStatusDevices:[],
  energyStatusItemsFilter: () => false,
}
